type Props = {
  isEnabled: boolean;
  click?: () => void;
  midium?: boolean;
  small?: boolean;
};

/* スイッチコンポーネント */
const Switch: React.FC<Props> = ({ isEnabled, click, midium, small }) => {
  return (
    <div
      className={
        `relative cursor-pointer ${
          small
            ? "h-[1.9rem] w-32"
            : midium
              ? "h-[2.33rem] w-[3.8rem]"
              : "h-[30px] w-[50px]"
        } max-w-full rounded-full before:absolute before:left-[5%] before:top-[10%] before:h-[80%] before:w-[50%] before:rounded-full before:bg-white before:transition-all before:delay-150 before:content-[''] ` +
        (isEnabled ? "bg-cgreen before:ml-[40%]" : "bg-[#dce3e3]")
      }
      onClick={click}
    />
  );
};

export default Switch;
